import {reduceRelayPaginationAction, RelayPaginationActionPayload, RelayPaginationState} from "../../pagination";
import {DEFAULT_PAGE_SIZE} from "../../const";
import {SortOrder} from "../domain";
import {ProgressPortrait, ProgressPortraitListFilterValue, ProgressPortraitSortBy} from "./domain";

export type ProgressPortraitListAction =
    | { type: 'SET_SELECTED'; selected: ProgressPortrait | null }
    | { type: 'SET_SORT_BY'; sortBy: ProgressPortraitSortBy }
    | { type: 'SET_FILTER'; filter: ProgressPortraitListFilterValue }
    | { type: 'SET_PAGE_SIZE'; pageSize: number }
    | RelayPaginationActionPayload;

export interface ProgressPortraitListState {
    pagination: RelayPaginationState;
    sortBy: ProgressPortraitSortBy;
    filter: ProgressPortraitListFilterValue;
    selected: ProgressPortrait | null;
    pageSize: number;
}

export function initState(clientGuid: string): ProgressPortraitListState {
    const defaultPagination = new RelayPaginationState('0', DEFAULT_PAGE_SIZE);
    return {
        pagination: defaultPagination,
        pageSize: defaultPagination.size,
        selected: null,
        filter: {
            clientGuid: clientGuid,
            reportDateFrom: null,
            reportDateTo: null,
        },
        sortBy: {
            column: "reportDate",
            order: SortOrder.DESC,
        },
    };
}

export function progressPortraitListReducer(
    state: ProgressPortraitListState,
    action: ProgressPortraitListAction
): ProgressPortraitListState {
    switch (action.type) {
        case 'SET_SELECTED':
            return {
                ...state,
                selected: action.selected
            };

        case 'RELAY_PAGINATION_ACTION':
            return {
                ...state,
                pagination: reduceRelayPaginationAction(state.pagination, action)
            };

        case 'SET_SORT_BY':
            return {
                ...state,
                sortBy: action.sortBy,
                pagination: new RelayPaginationState('0', state.pageSize),
            };

        case 'SET_FILTER':
            return {
                ...state,
                filter: action.filter,
                pagination: new RelayPaginationState('0', state.pageSize),
            };

        case 'SET_PAGE_SIZE':
            return {
                ...state,
                pageSize: action.pageSize,
                pagination: new RelayPaginationState('0', action.pageSize),
            };

        default:
            return state;
    }
}
